import { useEffect, useState } from "react";
import { Box, Typography, Button, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { api } from "../../services/apiService";
import "./OperadorLinha.css";

function OperadorLinhaEscolha() {
    const navigate = useNavigate();
    const { userInfo, isLoading } = useAuth();

    const [erroLinha, setErroLinha] = useState(null);
    const isOperador = userInfo?.roleNome === 'Operador';

    useEffect(() => {
        if (!isLoading && userInfo && !isOperador) {
            navigate("/dashboard", { replace: true });
        }
    }, [isLoading, userInfo, isOperador, navigate]);

    if (!isLoading && userInfo && !isOperador) return null;

const handleEscolhaLinha = async (idLinha) => {
        setErroLinha(null);
        if (isOperador && idLinha) {
            try {
                await api.operadorLinha.create({ idUsuario: userInfo.id, idLinha });
            } catch (error) {
                const msg =
                    error.response?.data?.message ||
                    error.response?.data?.Message ||
                    error.message ||
                    "Não foi possível reservar esta linha.";
                setErroLinha(msg);
                console.error("Erro ao registrar operador na linha:", error);
                return;
            }
        }

        navigate("/dashboard");
    };

    return (
        <Box className="operador-linha">
            <Box className="operador-linha__bg" aria-hidden />

            <Box className="operador-linha__overlay" aria-hidden />

            <Box className="operador-linha__content">
                <Typography variant="h4" className="operador-linha__title">
                    Selecione uma linha
                </Typography>

                {erroLinha && (
                    <Alert
                        severity="warning"
                        className="operador-linha__alert"
                        onClose={() => setErroLinha(null)}
                    >
                        {erroLinha}
                    </Alert>
                )}

                <Box className="operador-linha__buttons">
                    <Button
                        variant="contained"
                        size="large"
                        className="operador-linha__btn"
                        onClick={() => handleEscolhaLinha(1)}
                    >
                        Linha 8
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        className="operador-linha__btn"
                        onClick={() => handleEscolhaLinha(2)}
                    >
                        Linha 9
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        className="operador-linha__btn operador-linha__btn--viewer"
                        onClick={() => handleEscolhaLinha(null)}
                    >
                        Acessar como visualizador
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default OperadorLinhaEscolha;
